module.exports = __webpack_public_path__ + "img/ag_gallery_5.66098b16.jpg";